import { ToasterComponent } from '../../../toasterComponent/toasterComponent';
import { ViewContainerRef, ElementRef } from '@angular/core';
import { MDMService } from '../services/mdmService.service';
import { Observable } from 'rxjs';
import { DomSanitizer } from "@angular/platform-browser";
import { BiUrls } from '../../biUrls';
import * as FileSaver from 'file-saver';
var dimLvlPermComponent = /** @class */ (function () {
    function dimLvlPermComponent(dimLvlPermService, _sanitizer, toastr, vcr) {
        var _this = this;
        this.dimLvlPermService = dimLvlPermService;
        this._sanitizer = _sanitizer;
        this.toastr = toastr;
        this.vcr = vcr;
        this.mainPage = true;
        this.searchButton = false;
        this.accessDenied = false;
        this.saveButton = false;
        this.isEdit = false;
        this.loader = false;
        this.uploadSucess = false;
        this.add = false;
        this.uploadedDataList = [];
        this.removedDataList = [];
        this.nonExistentDimensions = [];
        this.nonExistentDimLevels = [];
        this.nonExistentUsers = [];
        this.nonExistentScopes = [];
        this.nonExistentAccess = [];
        this.file = null;
        this.totalEODR = 0;
        this.totalPages = 0;
        this.totalEmps = 0;
        this.totalLevels = 0;
        this.totalDimLevel = 0;
        this.page = 0;
        this.size = 10;
        this.currentPage = 1;
        this.startingPage = 0;
        this.endingPage = 0;
        this.pageSize = 10;
        this.dimList = [];
        this.employeeList = [];
        this.employeePageData = [];
        this.empIdList = [];
        this.employeeOrg = [];
        this.values = "";
        this.dimLevels = [];
        this.selectedDimension = "selectOne";
        this.filteredDimensionMap = new Map();
        this.deleteArray = [];
        this.filteredList = [];
        this.employeeOrgRelations = [];
        this.empOrgList = [];
        this.dimPermList = [];
        this.referencevariable = 'none';
        this.dimLvlValList = [];
        this.scopeList = [];
        this.dimensionMap = new Map();
        this.dimensionData = {
            id: null, name: '', description: '', dimTime: null, deleted: 0, dimHierarchyData: []
        };
        this.progress = 0;
        this.isProgress = false;
        this.count = 0;
        this.scopeMap = new Map();
        this.empOrgData = {
            employeeId: null,
            orgDimension: null,
            orgDimensionValue: "",
            scope: null,
            orgDimensionLevel: null,
            orgDimensionLevelName: "",
        };
        this.tabs = ['Individual', 'Bulk'];
        this.selectedTab = this.tabs[0];
        this.searchData = {
            "nameOrCodeOrEmail": "",
            "employeeCodes": [],
            "excludedEmployeeCodes": [],
            "includeEmpIds": [],
            "excludeEmpIds": [],
            "gradeIds": [],
            "mgrLevelIds": [],
            "designationIds": [],
            "categoryIds": [],
            "includeOrgIds": [],
            "excludeOrgIds": [],
            "supervisorIds": [],
            "primarySupervisorIds": [],
            "primarySupervisorNameOrCode": null,
            "primarySupervisorCods": [],
            "employeeStatus": null,
            "employeesWithOutSupervisor": null,
            "scorecardStates": null,
            "memberShipState": null,
            "programId": null,
            "pageSize": 10,
            "page": 1,
            "fetchSupervisorLevels": 0
        };
        // public dimensionHierachyData: any = {
        //     id: null,
        //     dimName: "",
        //     dimLevelName: "",
        //     dimValues: "",
        //     scope: "",
        //     dimId: "",
        // };
        // public scopeArray: any = [
        //     { value: 1, name: 'Team' },
        //     { value: 2, name: 'Individual' },
        //     { value: 3, name: 'All' },
        //     { value: 4, name: 'Custom 4' },
        //     { value: 5, name: 'Custom 5' },
        //     { value: 6, name: 'Custom 6' },
        //     { value: 7, name: 'Custom 7' },
        //     { value: 8, name: 'Custom 8' },
        //     { value: 9, name: 'Custom 9' },
        //     { value: 10, name: 'Custom 10' }
        // ];
        this.authPageNo = 0;
        this.authPageSize = 10;
        this.authStartingPage = 0;
        this.authEndingPage = 10;
        this.authCurrentPage = 1;
        this.authTotalRecs = 0;
        this.tableData = [];
        this.comment = '';
        this.fileNameToUpload = null;
        this.getDimLvlVal = function (keyword) {
            var self = _this;
            var request = { trendNeeded: false };
            request.dimensionYAxis = [{ "dimension": { "id": self.selectedDimension.dimId ? self.selectedDimension.dimId : self.selectedDimension.id }, "level": { "id": self.selectedDimLevel } }];
            if (self.selectedDimension == 'selectOne') {
                self.toastr.showError("Select Dimension to add values!");
                return;
            }
            if (keyword) {
                request.keyword = keyword;
                request.limit = 50;
                return Observable.create(function (observer) {
                    self.dimLvlPermService.dimensionData(request).then(function (res) {
                        if (res.response) {
                            observer.next(res.response.data);
                        }
                        else {
                            observer.next([]);
                        }
                        observer.complete();
                    }, function (err) {
                        observer.next([]);
                        observer.complete();
                    });
                });
            }
            else {
                return Observable.of([]);
            }
            // if (keyword != '') {
            //     self.filteredList = self.dimLvlValList.filter((dlv) => dlv.name.toLowerCase().includes(keyword.toLowerCase()));
            // } else {
            //     self.filteredList = [];
            // }
            // return Observable.of(self.filteredList);
        };
        this.autoCompleteListFormatter = function (data) {
            var html = "<span>" + data.name + "</span>";
            //let html = `<span> ${data.dimName} -- ${data.dimCode}</span>`;
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this.dimListFormatter = function (data) {
            var name = data.name ? data.name : data.dimHierarchyLevelName ? data.dimHierarchyLevelName : data.dimName;
            // let code = data.metadata ? data.metadata.d_l_id : data.dimHierarchyLevelId ? data.dimHierarchyLevelId : data.dimCode;
            var html = "<span>" + name + " -- " + data.dimCode + "</span>";
            return _this._sanitizer.bypassSecurityTrustHtml(html);
        };
        this.dimValueFormatter = function (data) {
            var name = data.name ? data.name : data.dimHierarchyLevelName ? data.dimHierarchyLevelName : data.dimName;
            var html = "" + name;
            return html;
        };
        this.searchDim = function (keyword) {
            var self = _this;
            if (keyword) {
                return self.dimLvlPermService.search1(BiUrls.BI_DIMENSION, BiUrls.SEARCH_DIMENSION, keyword);
            }
            else {
                return Observable.create(function (observer) {
                    observer.next([]);
                    observer.complete();
                });
            }
        };
        this.toastr.setViewRef(vcr);
    }
    dimLvlPermComponent.prototype.ngOnInit = function () {
        if (this.dimLvlPermService.isBIAdmin) {
            this.mainPage = true;
            this.loadScopes();
            this.loadDimensions();
            this.loadEmployees();
        }
        else {
            this.accessDenied = true;
        }
    };
    dimLvlPermComponent.prototype.loadScopes = function () {
        var _this = this;
        var self = this;
        self.dimLvlPermService.onStartUp(BiUrls.SCOPE).then(function (res) {
            if (res != undefined) {
                self.scopeList = res.data;
                _this.loadScopesIntoMap();
            }
        });
    };
    dimLvlPermComponent.prototype.loadScopesIntoMap = function () {
        var _this = this;
        this.scopeList.forEach(function (scope) {
            _this.scopeMap.set(scope.id, scope.name);
        });
    };
    // scopeData(num) {
    //     for (let scopes of this.scopeArray) {
    //         if (scopes.value == num) {
    //             return scopes.name;
    //         }
    //     }
    //     return '';
    // }
    dimLvlPermComponent.prototype.onBack = function () {
        this.mainPage = true;
        this.isEdit = false;
    };
    dimLvlPermComponent.prototype.bulkUpload = function (event) {
        var self = this;
        if (self.validateFile(self.file)) {
            var formdata1 = new FormData();
            self.loader = true;
            formdata1.append("file", self.file);
            self.dimLvlPermService.bulkUpload(BiUrls.PAGE, BiUrls.BULKUPLOAD_DIM_LVL_PERMISSION, formdata1).then(function (res) {
                if (res) {
                    if (!(res instanceof Object)) {
                        res = JSON.parse(res);
                    }
                    if (res.success) {
                        self.token = res.data;
                        if (self.token) {
                            self.isProgress = true;
                            setTimeout(function () {
                                self.checkProgress();
                            }, self.timeInterval * 1000);
                        }
                    }
                    else {
                        self.toastr.showError(res.errorMessage);
                    }
                    self.loadScopes();
                    // self.loadDimensions();
                    self.loadEmployees();
                }
                self.loader = false;
            }, function (error) {
                console.log(error);
            });
        }
        else {
            self.toastr.showError('Please Attach An Excel File');
        }
    };
    dimLvlPermComponent.prototype.validateFile = function (file) {
        var ext;
        if (file != null) {
            ext = file.name.split('.', 2);
        }
        else {
            ext = undefined;
        }
        if (ext == undefined || !(ext[1].toLowerCase() == 'xls' || ext[1].toLowerCase() == 'xlsx')) {
            return false;
        }
        else {
            return true;
        }
    };
    dimLvlPermComponent.prototype.checkProgress = function () {
        var self = this;
        if (self.count == 10) {
            self.count = 0;
            self.progress = 0;
            self.isProgress = false;
            self.toastr.showError("Bulk Upload Failed");
            return;
        }
        this.dimLvlPermService.getProgress(self.token, 'trackProgress/bi_bulk_dimLvlPerm_/').then(function (res) {
            if (res && res.success) {
                if (Math.round(+res.data) == self.progress) {
                    self.count += 1;
                }
                self.progress = Math.round(+res.data);
                if (self.progress < 100) {
                    setTimeout(function () {
                        self.checkProgress();
                    }, self.timeInterval * 1000);
                }
                else if (self.progress == 100) {
                    self.isProgress = false;
                    self.dimLvlPermService.getProgress(self.token, 'statusReport/bi_bulk_dimLvlPerm_/').then(function (res) {
                        self.progress = 0;
                        self.uploadSucess = true;
                        self.file = null;
                        self.fileInput.nativeElement.value = null;
                        self.toastr.showSuccess("Bulk Upload Successful");
                        self.loadUploadReport(res);
                    });
                }
            }
        });
    };
    dimLvlPermComponent.prototype.loadUploadReport = function (result) {
        var self = this;
        var statusMap = this.jsonToMap(result);
        this.nonExistentUsers = statusMap.get("NON_EXISTENT_EMPLOYEES");
        this.nonExistentDimensions = statusMap.get("NON_EXISTENT_DIMENSIONS");
        this.nonExistentDimLevels = statusMap.get("NON_EXISTENT_DIM_LEVELS");
        this.nonExistentScopes = statusMap.get("NON_EXISTENT_SCOPES");
        this.nonExistentAccess = statusMap.get("NON_EXISTENT_ACCESS");
        this.uploadedDataList = statusMap.get("UPLOADED_DATA");
        this.removedDataList = statusMap.get("REMOVED_DATA");
    };
    dimLvlPermComponent.prototype.jsonToMap = function (result) {
        var res = result;
        var jsonObj = JSON.parse(JSON.stringify(res.data));
        var map = new Map();
        for (var _i = 0, _a = Object.keys(jsonObj); _i < _a.length; _i++) {
            var k = _a[_i];
            map.set(k, jsonObj[k]);
        }
        return map;
    };
    dimLvlPermComponent.prototype.onScopeSelect = function (event) {
        this.scope = event.target.value;
    };
    dimLvlPermComponent.prototype.fileChange = function (event) {
        var size = +event.target.files[0].size / (1024 * 1024);
        if (size < 1) {
            this.timeInterval = 1; // less then 1 MB
        }
        else if (size < 5) {
            this.timeInterval = 2; // less then 5 MB
        }
        else if (size < 10) {
            this.timeInterval = 3; // less then 10 MB
        }
        else if (size > 10) {
            this.timeInterval = 5; // greater then 10 MB
        }
        this.file = event.target.files[0];
    };
    dimLvlPermComponent.prototype.loadDimensions = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            self.dimLvlPermService.onStartUp(BiUrls.DIMENSION).then(function (res) {
                self.dimList = [];
                self.totalPages = 0;
                if (res != undefined) {
                    self.dimList = res.data != undefined &&
                        res.data != undefined ? res.data :
                        self.toastr.showError('No results found');
                }
                if (self.dimList && self.dimList.length > 0) {
                    self.dimList.forEach(function (dim) {
                        self.dimensionMap.set(dim.id, dim);
                    });
                }
                self.loader = false;
                self.mainPage = true;
                resolve('completed');
            }, function (err) {
                console.error(err);
            });
        });
    };
    dimLvlPermComponent.prototype.loadEmpOrgDim = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            self.dimLvlPermService.onStartUp(BiUrls.DIM_LVL_PERMISSION + '/' + self.employeeId).then(function (res) {
                self.empOrgList = res != undefined && res.data != undefined ? res.data : [];
                self.setEmpOrgList();
                self.saveButton = false;
                self.loader = false;
                self.mainPage = true;
                resolve('completed');
            }, function (err) {
                console.error(err);
            });
        });
    };
    dimLvlPermComponent.prototype.setEmpOrgList = function () {
        var self = this;
        self.dimPermList = [];
        var _loop_1 = function (eodr) {
            var dimPermData = { id: '', dimName: '', dimLvlName: '', dimLvlVal: '', scope: '' };
            var dimLvlVal = eodr.orgDimensionValue;
            var dim = self.dimList.filter(function (d) { return d.id == eodr.orgDimension; });
            //let dimLvlId = self.getDimDataParts(dimLvlVal, 'dimLvlId');
            if (!dim[0]) {
                return "continue";
            }
            var dimLvl = dim[0].dimHierarchyData[0].dimHierarchyLevelData.filter(function (dl) { return dl.id == Number(eodr.orgDimensionLevel); });
            if (dimLvl[0] != undefined) {
                dimPermData.dimName = dim[0].displayName;
                dimPermData.dimLvlName = dimLvl[0].displayName;
                dimPermData.dimLvlVal = self.getDimDataParts(dimLvlVal, 'dimLvlVal');
                var scope = self.scopeList.filter(function (scp) { return scp.id == eodr.scope; });
                dimPermData.scope = scope[0] ? scope[0].name : '';
                dimPermData.id = eodr.id;
                self.dimPermList.push(dimPermData);
            }
        };
        for (var _i = 0, _a = self.empOrgList; _i < _a.length; _i++) {
            var eodr = _a[_i];
            _loop_1(eodr);
        }
    };
    dimLvlPermComponent.prototype.getDimDataParts = function (dimStr, type) {
        var self = this;
        var dimParts = dimStr.split('].[');
        if (type == 'dim') {
            return dimParts[0].substr(1);
        }
        else if (type == 'dimLvlVal') {
            return dimParts[2].slice(0, -1);
        }
        else {
            return dimParts[1];
        }
    };
    dimLvlPermComponent.prototype.loadEmployees = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var self = _this;
            self.loader = true;
            var url = BiUrls.PAGE + BiUrls.ALL_P_EMPLOYEES;
            self.employeeId = null;
            self.dimPermList = [];
            self.dimLvlPermService.getDataByPage(url, self.page, self.pageSize).then(function (res) {
                self.employeeList = [];
                self.empIdList = [];
                if (res == undefined) {
                    self.toastr.showError('Cannot load the Employee Data');
                }
                else {
                    self.employeeList = res.data.pageElements != undefined ?
                        res.data.pageElements.length == 0 ?
                            self.toastr.showWarning('No Employees to load') :
                            res.data.pageElements :
                        self.toastr.showError('No Employees found');
                    self.totalEmps = res.data.total;
                    self.setEndingPage(self.totalEmps);
                    for (var _i = 0, _a = self.employeeList; _i < _a.length; _i++) {
                        var emp = _a[_i];
                        self.empIdList.push(emp.id);
                    }
                }
                self.loader = false;
                self.mainPage = true;
                resolve('completed');
            }, function (err) {
                console.error(err);
            });
        });
    };
    dimLvlPermComponent.prototype.onDimensionSelection = function (event) {
        var value = event.dimId ? event.dimId : event.id;
        var self = this;
        self.dim = value;
        self.selectedDimLevel = event.dimHierarchyLevelId;
        // this.dimLevels = [];
        // this.dimLvlValList = [];
        // if (this.levelName != null) {
        //     this.levelName = "";
        // }
        this.selectedDimension = event;
        // if (this.selectedDimension != "selectOne") {
        //     self.dimLevels = self.dimensionMap.get(+value).dimHierarchyData[0].dimHierarchyLevelData
        //     self.selectedDimensionName = event.name;
        //     self.dimLevels = _.sortBy(self.dimLevels, function (s) {
        //         return self.getDecodedValue(s.displayName).charCodeAt();
        //     });
        // }
        // this.onDimensionLevelSelect(event.dimHierarchyLevelId);
        this.dimAutoComplete.nativeElement.value = '';
    };
    dimLvlPermComponent.prototype.onDimensionLevelSelect = function (event) {
        console.log("inside dimension level select");
        var self = this;
        // let value = event.target.value;
        var value = event;
        this.elementDiv.nativeElement.value = null;
        self.filteredList = [];
        self.dimLvlValList = [];
        self.selectedDimLevel = value;
        if (self.selectedDimLevel != 'selectOne') {
            self.dimLevels.filter(function (item) {
                if (item.id == value) {
                    self.selectedDimensionLevelName = item.displayName;
                }
            });
            var dimValObj = {
                "trendNeeded": false,
                "dimensionYAxis": [
                    { "dimension": { "id": self.dim }, "level": { "id": self.selectedDimLevel } }
                ]
            };
            self.dimLvlPermService.getDimLevelValues(dimValObj).then(function (res) {
                self.dimLvlValList = (res.response != undefined && res.response.data != undefined) ? res.response.data : [];
            });
        }
        else {
            self.toastr.showError('Please Select Dimension Level');
        }
    };
    dimLvlPermComponent.prototype.orgNameValueFormatter = function (data) {
        return "" + data.name;
    };
    dimLvlPermComponent.prototype.onSelectDimLvlVal = function (event) {
        var self = this;
        self.selecteDimensionValue = event;
        self.dimValue = event.key;
        self.elementDiv.nativeElement.value = '';
    };
    dimLvlPermComponent.prototype.getDecodedValue = function (encodedText) {
        if (!encodedText)
            return "";
        var x;
        x = document.createElement("TEXTAREA");
        x.innerHTML = encodedText;
        return x.value;
    };
    dimLvlPermComponent.prototype.loaderControl = function (event) {
        this.loader = event;
    };
    dimLvlPermComponent.prototype.employeesFound = function (event) {
        this.employeeList = event;
    };
    dimLvlPermComponent.prototype.pageDataControl = function (event) {
        this.employeePageData = event;
        this.totalEmps = event.totalElements;
        this.setEndingPage(this.totalEmps);
    };
    dimLvlPermComponent.prototype.onSelectEmployee = function (event) {
        this.employeeId = event.target.id;
        this.loadEmpOrgDim();
    };
    dimLvlPermComponent.prototype.onPageChange = function (event) {
        console.log('On Page Change Controller ...');
        this.currentPage = event;
        this.page = this.currentPage - 1;
        this.searchData.page = event;
        this.getEmployee();
        this.setEndingPage(this.totalEmps);
    };
    dimLvlPermComponent.prototype.OnPageSizeChanged = function (event) {
        console.log('On Page-Size Change Controller ...');
        this.pageSize = event.target.value;
        this.searchData.pageSize = this.pageSize;
        this.getEmployee();
        this.setEndingPage(this.totalEmps);
    };
    dimLvlPermComponent.prototype.onClickOfAdd = function () {
        var self = this;
        var validate = this.validater();
        if (validate != '') {
            this.toastr.showError(validate);
        }
        else {
            if (this.isDuplicateDimensionFilter()) {
                this.toastr.showError("Dimension Filter Already Exists");
                return;
            }
            self.saveButton = true;
            self.loader = true;
            self.empOrgData.employeeId = self.employeeId;
            self.empOrgData.orgDimension = self.selectedDimension.dimId ? self.selectedDimension.dimId : self.selectedDimension.id;
            self.empOrgData.scope = self.scope;
            self.empOrgData.orgDimensionLevel = Number(self.selectedDimLevel);
            self.empOrgData.orgDimensionValue = self.dimValue;
            self.dimLvlPermService.save(BiUrls.DIM_LVL_PERMISSION, self.empOrgData).then(function (success) {
                if ((success.errorMessage != null || success.errorMessage != undefined)) {
                    console.log(success.errorMessage);
                    self.mainPage = false;
                    self.accessDenied = true;
                    self.add = false;
                    return;
                }
                if (success.message) {
                    console.log(success.message);
                    self.toastr.showError(success.message);
                    self.resetDimLvlValues();
                    self.saveButton = false;
                    self.loader = false;
                    return;
                }
                self.toastr.showSuccess('Dimension Filter Added successfully');
                self.loadEmpOrgDim();
                self.employeeOrgRelations = success;
                self.resetDimLvlValues();
                self.loader = false;
            }, function (error) {
                self.toastr.showError('Failed to add Dimension Filter');
                console.log(error);
            });
        }
    };
    dimLvlPermComponent.prototype.resetDimLvlValues = function () {
        var self = this;
        // self.employeeId = null;
        self.selectedDimension = "selectOne";
        self.selectedDimLevel = undefined;
        self.dimValue = undefined;
        self.filteredList = [];
        self.dimLevels = [];
        self.scope = null;
        self.elementDiv.nativeElement.value = null;
        self.selecteDimensionValue = null;
    };
    dimLvlPermComponent.prototype.validater = function () {
        //if (this.employeeOrgRelations.length == 0 || this.selectedEmployee == null || this.selectedEmployee == "selectOne") {
        if (this.employeeId == undefined) {
            return 'Please select the Employee for further actions';
        }
        //if (this.dimArray == null || this.dimArray == undefined || this.selectedDimension == "selectOne") {
        if (this.selectedDimension == "selectOne") {
            return 'Please select dimension to add the permission';
        }
        if (this.selectedDimLevel == undefined) {
            return 'Please select dimension level to add the permission';
        }
        if (this.dimValue == undefined || this.dimValue.trim() == '') {
            return 'Please select dimension level value to add the permission';
        }
        if (this.scope == undefined) {
            return 'Please select scope to add the permission';
        }
        return '';
    };
    dimLvlPermComponent.prototype.isDuplicateDimensionFilter = function () {
        var self = this;
        var isDuplicate = false;
        for (var _i = 0, _a = self.dimPermList; _i < _a.length; _i++) {
            var dimPerm = _a[_i];
            if (dimPerm.dimName == self.selectedDimension.dimDisplayName &&
                dimPerm.dimLvlName == self.selectedDimension.dimHierarchyLevelName &&
                dimPerm.dimLvlVal == self.selecteDimensionValue.name &&
                dimPerm.scope == self.scopeMap.get(Number(self.scope))) {
                isDuplicate = true;
                break;
            }
        }
        return isDuplicate;
    };
    // setOrgData() {
    //     let orgData = this.empOrgData;
    //     orgData.employeeId = this.selectedEmployee;
    //     orgData.orgDimensionValue = this.values;
    //     //orgData.orgDimension = this.dimArray.id;
    //     orgData.scope = this.scope;
    //     orgData.orgDimensionLevel = this.dimensionLevelId;
    //     orgData.orgDimensionLevelName = this.levelName;
    //     return orgData;
    // }
    dimLvlPermComponent.prototype.validationBeforeSaving = function (orgData, levelName, values) {
        var msg = "Please Select all the fields to add the permission";
        if (orgData.employeeId == null) {
            return msg;
        }
        if (orgData.orgDimension == "") {
            return msg;
        }
        if (levelName == undefined || levelName == "" || levelName == "selectOne") {
            return msg;
        }
        if (values == "selectOne" || values == "") {
            return msg;
        }
        if (orgData.scope == undefined || orgData.scope == 0 || orgData.scope == "selectOne") {
            return msg;
        }
        return "";
    };
    // getEmployeeOrgRelation(event) {
    //     let self = this;
    //     self.employeeOrg = [];
    //     if (typeof event != 'object') {
    //         self.selectedEmployee = event;
    //     } else {
    //         self.selectedEmployee = event.target.value;
    //     }
    //     if (self.selectedEmployee == "selectOne") {
    //         return;
    //     }
    //     if (self.selectedEmployee != "selectOne") {
    //         self.dimLvlPermService.getDataById(BiUrls.DIM_LVL_PERMISSION, this.selectedEmployee).then((res) => {
    //             for (let employee of self.employeeOrgRelations) {
    //                 if (employee.orgDimensionValue != undefined || employee.orgDimensionValue != null) {
    //                     let dimLevels = employee.orgDimensionValue.split('].[')
    //                     let dimensionHierachyData = self.empOrgData
    //                     dimensionHierachyData.id = employee.id;
    //                     dimensionHierachyData.scope = self.scopeData(employee.scope);
    //                     dimensionHierachyData.dimName = dimLevels[0].slice(1);
    //                     dimensionHierachyData.dimLevelName = employee.orgDimensionLevelName;
    //                     dimensionHierachyData.dimValues = dimLevels[dimLevels.length - 1].slice(0, dimLevels[dimLevels.length - 1].length - 1);
    //                     self.employeeOrg.push(dimensionHierachyData);
    //                 }
    //             }
    //         },
    //             function (error) {
    //                 console.log(error);
    //             }
    //         );
    //     }
    // }
    dimLvlPermComponent.prototype.onSelectToDelete = function (event) {
        if (event.target.checked == true) {
            this.deleteArray.push(Number(event.target.id));
        }
        else if (event.target.checked == false) {
            var index = this.deleteArray.indexOf(Number(event.target.id));
            this.deleteArray.splice(index, 1);
        }
        return this.deleteArray;
    };
    dimLvlPermComponent.prototype.deleteConfirm = function (event) {
        if (this.deleteArray.length == 0) {
            return;
        }
        var decision = confirm('Do you want remove this permission?');
        if (decision == true) {
            this.onDelete(event);
        }
    };
    dimLvlPermComponent.prototype.onDelete = function (event) {
        var self = this;
        self.loader = true;
        var url = BiUrls.DIM_LVL_PERMISSION + BiUrls.REMOVE_MULTIPLE_DIM_LVL_PERMSSIONS;
        self.dimLvlPermService.deleteEmpOrgDimRel(url, self.deleteArray).then(function (response) {
            self.toastr.showSuccess('Dimension level permissions removed successfully');
            self.deleteArray = [];
            self.loadEmpOrgDim();
            self.loader = false;
        }, function (err) {
            self.toastr.showError('Unable to remove dimension level permissions : ' + err.errorCode);
        });
    };
    dimLvlPermComponent.prototype.setEndingPage = function (total) {
        var self = this;
        if (self.currentPage == 1) {
            this.startingPage = 0;
            if (total > this.pageSize) {
                this.endingPage = this.pageSize;
            }
            else {
                this.endingPage = total;
            }
        }
        else {
            this.startingPage = 0 + ((self.currentPage - 1) * +this.pageSize);
            this.endingPage = +this.pageSize + ((self.currentPage - 1) * +this.pageSize);
            if (this.endingPage > total) {
                this.endingPage = total;
            }
        }
    };
    dimLvlPermComponent.prototype.showSearchFilter = function (event) {
        this.searchData = event;
        this.searchData.page = 1;
        this.getEmployee();
    };
    dimLvlPermComponent.prototype.getEmployee = function () {
        try {
            var self_1 = this;
            self_1.loader = true;
            self_1.dimLvlPermService.getEmployee(this.searchData).then(function (result) {
                self_1.empIdList = [];
                self_1.employeeList = result.content;
                self_1.employeePageData = result;
                self_1.totalEmps = result.totalElements;
                self_1.setEndingPage(self_1.totalEmps);
                self_1.loader = false;
            });
        }
        catch (e) {
            console.log("getAllEmployeeData error catch", e);
        }
    };
    dimLvlPermComponent.prototype.removeDimSelected = function () {
        this.selectedDimension = 'selectOne';
        this.selecteDimensionValue = null;
    };
    dimLvlPermComponent.prototype.removeDimValue = function () {
        this.selecteDimensionValue = null;
    };
    dimLvlPermComponent.prototype.beforeChange = function (event) {
        if (event.nextId == 'individual') {
            this.selectedTab = event.nextId;
        }
        else if (event.nextId == 'bulk') {
            this.selectedTab = event.nextId;
            this.getUserDimRelsHistory();
        }
    };
    dimLvlPermComponent.prototype.chooseFile = function (event) {
        if (event.target.files && event.target.files.length > 0) {
            var self_2 = this;
            this.file = event.target.files[0];
            self_2.fileNameToUpload = event.target.files[0].name;
            event.srcElement.value = null;
        }
    };
    dimLvlPermComponent.prototype.validateBulkOpInput = function () {
        var self = this;
        var ext = self.file.name.split('.', 2);
        var isValid = true;
        if (ext[1].toLowerCase() != 'xlsx') {
            this.toastr.showError("Please Attach An Excel File");
            isValid = false;
        }
        if (self.comment.trim() === '') {
            this.toastr.showError("Comment is mandatory");
            isValid = false;
        }
        return isValid;
    };
    dimLvlPermComponent.prototype.initBulkUserDimRels = function (event) {
        var self = this;
        var formdata = new FormData();
        if (self.validateBulkOpInput()) {
            self.loader = true;
            formdata.append('file', self.file);
            formdata.append('comment', self.comment);
            self.dimLvlPermService.bulkUpload('auth/', 'processBulkUserDimRel', formdata).then(function (res) {
                if (res) {
                    if (res.status == 409) {
                        self.toastr.showError(JSON.parse(res.error).message);
                    }
                    else {
                        if (!(res instanceof Object)) {
                            res = JSON.parse(res);
                        }
                        if (res.success) {
                            self.uploadSucess = true;
                            self.file = null;
                            self.fileInput.nativeElement.value = null;
                            self.token = res.data;
                            self.isProgress = true;
                        }
                        else {
                            self.toastr.showError(res.errorMessage);
                        }
                    }
                    self.getUserDimRelsHistory();
                }
                self.loader = false;
                self.resetBulkOperationParams();
            }, function (err) {
                console.error(err);
                self.resetBulkOperationParams();
                self.loader = false;
            });
        }
    };
    dimLvlPermComponent.prototype.resetBulkOperationParams = function () {
        this.comment = '';
        this.fileNameToUpload = null;
    };
    dimLvlPermComponent.prototype.downloadFiles = function (url) {
        var _this = this;
        try {
            this.dimLvlPermService.mdmService.getBlob(url).subscribe(function (result) {
                var name = _this.getFileNameFromHeader(result.headers);
                FileSaver.saveAs(result.body, name);
            });
        }
        catch (e) {
            console.log('download error caught', e);
        }
    };
    dimLvlPermComponent.prototype.downloadTemplate = function () {
        var url = this.dimLvlPermService.base_url + 'biAdmin/auth/downloadTemplate/USER_DIMENSION_FILTER_TEMPLATE';
        this.downloadFiles(url);
    };
    dimLvlPermComponent.prototype.downloadUserDimRelsFiles = function (filePath) {
        var url = this.dimLvlPermService.base_url + 'biAdmin/auth/downloadFile/' + filePath;
        this.downloadFiles(url);
    };
    dimLvlPermComponent.prototype.getFileNameFromHeader = function (headers) {
        var header = headers.get('Content-Disposition');
        if (header == null) {
            return 'User_Dimension_Filter_Template.xlxs';
        }
        else {
            if (!header) {
                return null;
            }
            var result = header.split(';')[1].trim().split('=')[1];
            return result.replace(/'/g, '');
        }
    };
    dimLvlPermComponent.prototype.getUserDimRelsHistory = function () {
        var _this = this;
        var self = this;
        try {
            var url = self.dimLvlPermService.base_url +
                'biAdmin/auth/getAllUploadStatus/?processType=BI_USER_DIM_FILTER_UPLOAD&' +
                'page=' + self.authCurrentPage + '&pageSize=' + self.authPageSize;
            self.dimLvlPermService.mdmService.get(url).subscribe(function (response) {
                _this.handleUserDimRelsHistoryResponse(response);
            });
        }
        catch (e) {
            console.log('Error: getUserDimRelsHistory', e);
        }
    };
    dimLvlPermComponent.prototype.handleUserDimRelsHistoryResponse = function (response) {
        if (response && response.content) {
            this.authTotalRecs = response.totalElements;
            this.tableData = response.content;
            this.setPaginationParams();
        }
    };
    dimLvlPermComponent.prototype.setPaginationParams = function () {
        var self = this;
        if (self.authCurrentPage == 1) {
            self.authStartingPage = 0;
            if (self.authTotalRecs > self.authPageSize) {
                self.authEndingPage = self.authPageSize;
            }
            else {
                self.authEndingPage = self.authTotalRecs;
            }
        }
        else {
            self.authStartingPage = 0 + ((self.authCurrentPage - 1) * +self.authPageSize);
            self.authEndingPage = +self.authPageSize + ((self.authCurrentPage - 1) * +self.authPageSize);
            if (self.authEndingPage > self.authTotalRecs) {
                self.authEndingPage = self.authTotalRecs;
            }
        }
    };
    dimLvlPermComponent.prototype.onAuthHistoryPageSizeChanged = function (event) {
        this.authPageSize = event.target.value;
        this.getUserDimRelsHistory();
    };
    dimLvlPermComponent.prototype.onAuthHistoryPageChange = function (event) {
        if (typeof event == 'number' && !isNaN(event)) {
            this.authCurrentPage = event;
            this.getUserDimRelsHistory();
        }
    };
    return dimLvlPermComponent;
}());
export { dimLvlPermComponent };



// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/dimLvlPermissions.component.ts.pre-build-optimizer.js